<template lang="pug">
.vprComponent
  ui-loader(v-if="isLoading")
  template(v-else)

    .vprContentsComponent( v-if="$route.name === 'VprContents'" )
      .navbar
        a.back( @click="onBackClick" )
          ui-svg-icon.backIcon(
            name="arrow-back"
            :size="16"
          )
          span Назад

      vpr-contents-content-component(
        v-if="userItem"
        :user-item="userItem"
      )

    template(v-else)
      inner-view-component(:user-item="userItem")

</template>

<script>
import { computed, inject } from 'vue'
import InnerViewComponent from './VprContentsInnerView'
import VprContentsContentComponent from './VprContentsContent'

export default {
  components: {
    VprContentsContentComponent,
    InnerViewComponent
  },
  setup () {
    const controller = inject('controller')

    return {
      userItem: computed(() => controller.childVpr.value?.userItem ?? null),
      isLoading: controller.isLoading
    }
  },
  methods: {
    onBackClick () {
      const backURL = this.$router.options.history?.state?.back ?? ''
      if (backURL.match('/vpr')) {
        this.$router.push({ name: 'VprProgress' })
      } else {
        this.$router.push({ name: 'Catalog' })
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.vprComponent
  .vprContentsComponent
    > .navbar
      margin-bottom: 6*$u
      > a
        width: fit-content
        display: flex
        align-items: center
        color: $cBlue
        cursor: pointer

        > span
          @include font('t16-medium')
          margin-left: 2.5*$u

        &:hover
          color: $cLightBlue
        &:active
          color: $cDarkBlue
</style>
